var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('q-ajax-bar',{staticClass:"AjaxLoading__bar",attrs:{"color":"secondary","size":"3px","position":"top"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }